<template>
  <v-data-table :headers="headers" :items="roles">
    <template v-slot:top>
      <FormDialog :dialog="create_dialog" :close="closeCreateDialog" :title="modal_title">
        <FormRole :editData="role_selected" :closeDialog="closeCreateDialog" />
      </FormDialog>
      <div class="d-flex justify-end">
        <v-btn color="green lighten-1" dark class="my-2" @click="openCreate">
          <v-icon class="mr-1">mdi-plus</v-icon>
          Criar</v-btn>
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex'
import FormDialog from '@/components/dialogs/FormDialog.vue'
import FormRole from './FormRole.vue'

export default {
  name: 'RoleList',
  components: { FormDialog, FormRole },
  data: () => {
    return {
      role_selected: {},
      create_dialog: false,
      headers: [
        { text: '#', value: 'id' },
        { text: 'Cargo', value: 'role' },
        { text: 'Ações', value: 'actions' },
      ],
    }
  },
  computed: {
    ...mapState('utils', ['roles']),
    modal_title() {
      if (this.role_selected.role) {
        return 'Editar Cargo'
      } else {
        return 'Cadastrar Cargo'
      }
    },
  },
  methods: {
    openCreate() {
      this.create_dialog = true
    },
    closeCreateDialog() {
      this.create_dialog = false
      this.role_selected = {}
    },
    editItem(data) {
      this.role_selected = data
      this.openCreate()
    },
  },
}
</script>
